import jwtDecode from "jwt-decode";
import _ from "lodash";
import Cookies from "js-cookie";

const JWT_COOKIE_NAME = "jwt.access_token" as const;
const JWT_REFRESH_COOKIE_NAME = "jwt.refresh_token" as const;
export const JUST_LOGGED_IN_KEY = "justLoggedIn";

export function setAccessToken(token: string, site?: string, setToastKey = true) {
  const payload = jwtDecode(token);
  const exp = _.get(payload, "exp", 0) * 1000;
  const expires = new Date(exp);
  const domain = getHostName();
  const pathSite = site ?? getSite();
  Cookies.set(JWT_COOKIE_NAME, token, {
    domain,
    path: `/${pathSite}`,
    expires,
    secure: !import.meta.env.VITE_HOSTNAME,
    sameSite: "Strict",
  });
  if (setToastKey) localStorage.setItem(JUST_LOGGED_IN_KEY, "true");
}

// Set refresh token cookie - this is only used to get the refresh token in the branded app, so it only needs to exist in the current session, hence no 'expires' field.
export function setRefreshToken(token: string) {
  const domain = getHostName();
  Cookies.set(JWT_REFRESH_COOKIE_NAME, token, {
    domain,
    secure: !import.meta.env.VITE_HOSTNAME,
    sameSite: "Strict",
  });
}

export function removeAccessToken() {
  const domain = getHostName();
  const site = getSite();
  Cookies.remove(JWT_COOKIE_NAME, { domain, path: `/${site}`, secure: true, sameSite: "Strict" });
  // Remove any root domain cookies too
  Cookies.remove(JWT_COOKIE_NAME, { domain, path: `/`, secure: true, sameSite: "Strict" });
}

export function getAccessToken(): string | null {
  const cookie = Cookies.get(JWT_COOKIE_NAME);
  if (!cookie || cookie.length === 0) return null;
  return cookie;
}

function getHostName() {
  return window.location.hostname === "localhost" ? "" : `.${window.location.hostname.split(".").slice(-2).join(".")}`;
}

function getSite() {
  return window.location.pathname.split("/")[1];
}

export function checkSiteMatch(site: string | null | undefined) {
  return getSite() === site;
}
